module.exports = __webpack_public_path__ + "img/ícone-emblema-segurança-alterado.cf369925.svg";